import { CommonModule } from "@angular/common";
import { Component, forwardRef, Input, OnInit, signal } from "@angular/core";
import {
  ControlValueAccessor,
  FormControl,
  NG_VALUE_ACCESSOR,
} from "@angular/forms";

@Component({
  selector: "app-rating-star",
  templateUrl: "./rating-star.component.html",
  styleUrl: "./rating-star.component.scss",
  standalone: false,
  providers: [
    {
      provide: NG_VALUE_ACCESSOR,
      useExisting: forwardRef(() => RatingStarComponent),
      multi: true,
    },
  ],
})
export class RatingStarComponent implements OnInit, ControlValueAccessor {
  writeValue(value: number): void {
    this.rating = value ?? 0;
  }
  registerOnChange(fn: any): void {
    this.onChange = fn;
  }
  registerOnTouched(fn: any): void {
    this.onTouched = fn;
  }
  setDisabledState?(isDisabled: boolean): void { }

  onChange = (_: number) => { };
  onTouched = () => { };

  @Input()
  rating: number = 0;

  @Input() modeForm: boolean = false;
  @Input() iconSize: string = "fs-5";
  @Input() gapMargin: string = "2";

  form = new FormControl();
  isSelect = signal<boolean>(false);
  starArray: number[] = Array(5).fill(0);

  ngOnInit(): void {
    this.writeValue(this.rating);
  }

  selectStar(score: number) {
    if (!this.modeForm) {
      return;
    }
    if (score === this.rating) {
      this.rating = 0;
    } else {
      this.rating = score;
    }
    this.onChange(this.rating); // 🔥 สำคัญมาก
    this.onTouched();
  }
}
